import DashboardIcon from "@material-ui/icons/Dashboard";
import EmailIcon from "@material-ui/icons/Email";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import ListAltIcon from "@material-ui/icons/ListAlt";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import accountingBlack from "./assets/flaticons/accounting-black.png";
import accountingWhite from "./assets/flaticons/accounting-white.png";
import administrationBlack from "./assets/flaticons/administrator-black.png";
import administrationWhite from "./assets/flaticons/administrator-white.png";
import allEstimationBlack from "./assets/flaticons/all-estimation-black.png";
import allEstimationWhite from "./assets/flaticons/all-estimation-white.png";
import operationBlack from "./assets/flaticons/black-operation.png";
import bookBlack from "./assets/flaticons/book-black.png";
import bookWhite from "./assets/flaticons/book-white.png";
import calculatorBlack from "./assets/flaticons/calculator-black.png";
import calculatorWhite from "./assets/flaticons/calculator-white.png";
import cargoAnalysisBlack from "./assets/flaticons/cargo-analysis-black.png";
import cargoAnalysisWhite from "./assets/flaticons/cargo-analysis-white.png";
import cargocargoBlack from "./assets/flaticons/cargo-cargo-black.png";
import cargocargoWhite from "./assets/flaticons/cargo-cargo-white.png";
import contractBlack from "./assets/flaticons/contract-black.png";
import contractWhite from "./assets/flaticons/contract-white.png";
import dashboardBlack from "./assets/flaticons/dashboard-black.png";
import dashboardWhite from "./assets/flaticons/dashboard-white.png";
import distanceBlack from "./assets/flaticons/distance-black.png";
import distanceWhite from "./assets/flaticons/distance-white.png";
import emailBlack from "./assets/flaticons/email-parser-black.png";
import emailWhite from "./assets/flaticons/email-parser-white.png";
import fuelSupplyBlack from "./assets/flaticons/fuel-supply-black.png";
import fuelSupplyWhite from "./assets/flaticons/fuel-supply-white.png";
import laytimeBlack from "./assets/flaticons/laytime-black.png";
import laytimeWhite from "./assets/flaticons/laytime-white.png";
import mailboxBlack from "./assets/flaticons/mailboxBlack.png";
import mailboxWhite from "./assets/flaticons/mailboxWhite.png";
import martixCurveBlack from "./assets/flaticons/matrix-curve-black.png";
import martixCurveWhite from "./assets/flaticons/matrix-curve-white.png";
import orderBlack from "./assets/flaticons/order-black.png";
import orderWhite from "./assets/flaticons/order-white.png";
import portInfoBlack from "./assets/flaticons/port-info-black.png";
import portInfoWhite from "./assets/flaticons/port-info-white.png";
import portServiceBlack from "./assets/flaticons/port-service-black.png";
import portServiceWhite from "./assets/flaticons/port-service-white.png";
import riskManagementBlack from "./assets/flaticons/risk-management-black.png";
import riskManagementWhite from "./assets/flaticons/risk-management-white.png";
import shipManagementBlack from "./assets/flaticons/ship-management-black.png";
import shipManagementWhite from "./assets/flaticons/ship-management-white.png";
import Ship from "./assets/flaticons/ship.png";
import sofBlack from "./assets/flaticons/sof-black.png";
import sofWhite from "./assets/flaticons/sof-white.png";
import supportBlack from "./assets/flaticons/support-black.png";
import supportWhite from "./assets/flaticons/support-white.png";
import userDashboardBlack from "./assets/flaticons/user-dashboard-black.png";
import userDashboardWhite from "./assets/flaticons/user-dashboard-white.png";
import vesselvesselBlack from "./assets/flaticons/vesselvessel-black.png";
import vesselvesselWhite from "./assets/flaticons/vesselvessel-white.png";
import voyageListBlack from "./assets/flaticons/voyage-list-black.png";
import voyageListWhite from "./assets/flaticons/voyage-list-white.png";
import voyagesBlack from "./assets/flaticons/voyages-black.png";
import voyagesWhite from "./assets/flaticons/voyages-white.png";
import operationWhite from "./assets/flaticons/white-operation.png";
import Users from "./assets/images/user.png";
import { initialRowData } from "./containers/User/Dashboard/Vessel/editVesselOnFleetAdd";

const keys = require("./config/keys");

// export const API_URL = "http://54.221.198.168:8083"
// export const API_URL = "https://fleetsigma.com"
// export const API_URL = "http://fs-staging.fleetsigma.com"
// export const API_URL = "http://localhost:8080";
// export const API_URL = "https://voy-calc-be-git-13may24-manoj-kumars-projects-0a428b84.vercel.app"
// export const API_URL = "https://voy-calc-be.vercel.app";
// export const API_URL = "https://dryapi.smartseafreight.com";
// export const API_URL = "https://devapi.shippinginnovationlabs.com"
export const API_URL = process.env.REACT_APP_API_URL;
export const MARKETING_BASE_URL = process.env.REACT_APP_MARKETING_BASE_URL;
console.log("🚀 ~ MARKETING_BASE_URL:", MARKETING_BASE_URL)
export const API_BASE_URL = keys.apiBaseUrl;

export const ACCESS_TOKEN = "accessToken";

export const OAUTH2_REDIRECT_URI = keys.redirectUri;

export const GOOGLE_AUTH_URL =
  API_BASE_URL + "/api/auth/google?redirect_uri=" + OAUTH2_REDIRECT_URI;

// export const CargoVideoUrl = "https://devsmartseafreight.s3.ap-south-1.amazonaws.com/documents/outpu26+(1).webm"

export const CargoVideoUrl = "https://devsmartseafreight.s3.ap-south-1.amazonaws.com/videos%2F83716248-952e-41a0-9c16-f5f01dfb000b.webm"

export const WS_URL = "ws://localhost:5001";
//leaflet js
export const userDrawerList = [
  {
    label: "User List",
    url: "/user-list",
    shortLabel: "user-list",
    blackImg: Users,
    whiteImg: Users,
    icon: <Users />,
    activeRoutes: ["/user-list"],
    description: "Manage platform users, view profiles, and control account access across your organization.",
  },
  {
    label: "Cargo Vessel Playground",
    url: "/cargo-vessel-playground",
    shortLabel: "cargo-vessel-playground",
    blackImg: martixCurveBlack,
    whiteImg: martixCurveWhite,
    icon: <martixCurveBlack />,
    activeRoutes: ["/cargo-vessel-playground"],
    description: "Model and simulate cargo-vessel combinations with real-time voyage cost estimates, fuel calculations, and route optimization.",
  },
  {
    label: "Accounting",
    url: "/accounting",
    shortLabel: "accounting",
    blackImg: accountingBlack,
    whiteImg: accountingWhite,
    icon: <accountingBlack />,
    activeRoutes: ["/accounting"],
    description: "Comprehensive financial management — invoicing, payments, receivables, and voyage-level P&L reports.",
  },
  {
    label: "Risk Management",
    url: "/risk-management",
    shortLabel: "risk-management",
    blackImg: riskManagementBlack,
    whiteImg: riskManagementWhite,
    icon: <riskManagementBlack />,
    activeRoutes: ["/risk-management"],
    description: "Assess and mitigate chartering risks with exposure analysis, freight hedging tools, and market volatility indicators.",
  },
  {
    label: "Ship Management",
    url: "/ship-management",
    shortLabel: "ship-management",
    blackImg: shipManagementBlack,
    whiteImg: shipManagementWhite,
    icon: <shipManagementBlack />,
    activeRoutes: ["/ship-management"],
    description: "Centralized vessel operations — maintenance scheduling, certification tracking, and crew management.",
  },
  {
    label: "Port Service",
    url: "/port-service",
    shortLabel: "port-service",
    blackImg: portServiceBlack,
    whiteImg: portServiceWhite,
    icon: <portServiceBlack />,
    activeRoutes: ["/port-service"],
    description: "Manage port calls, agent nominations, berth bookings, and all port-related services across your global operations.",
  },
  {
    label: "Fuel Supply",
    url: "/fuel-supply",
    shortLabel: "fuel-supply",
    blackImg: fuelSupplyBlack,
    whiteImg: fuelSupplyWhite,
    icon: <fuelSupplyBlack />,
    activeRoutes: ["/fuel-supply"],
    description: "Manage bunker procurement with price comparisons, supplier management, and fuel quality tracking across ports worldwide.",
  },
  {
    label: "Administration",
    url: "/administration",
    shortLabel: "administration",
    blackImg: administrationBlack,
    whiteImg: administrationWhite,
    icon: <administrationBlack />,
    activeRoutes: ["/administration"],
    description: "Platform administration including user management, role assignments, system configuration, and audit trails.",
  },
  {
    label: "Knowledge Partner",
    url: "/knowledge-partner",
    shortLabel: "knowledge-partner",
    blackImg: administrationBlack,
    whiteImg: administrationWhite,
    icon: <administrationBlack />,
    activeRoutes: ["/knowledge-partner"],
    description: "Access curated maritime knowledge resources, expert insights, regulatory updates, and industry best practices.",
  },
  {
    label: "Dashboard",
    url: "/",
    shortLabel: "D",
    icon: <DashboardIcon />,
    blackImg: dashboardBlack,
    whiteImg: dashboardWhite,
    activeRoutes: [
      "/",
      "/vessel/:id",
    ],
    description:
      "You can manage users, organizations and vessels from dashboard.",
  },
  {
    label: "Setup Organization",
    url: "/organization",
    shortLabel: "SO",
    blackImg: administrationBlack,
    whiteImg: administrationWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/organization"],
  },
  {
    label: "User Management for Organization",
    url: "/userOrganization",
    shortLabel: "UMO",
    blackImg: Users,
    whiteImg: Users,
    icon: <Users />,
    activeRoutes: ["/userOrganization"],
  },
  {
    label: "Vessel Information",
    url: "/vesselInformation",
    shortLabel: "VI",
    blackImg: Ship,
    whiteImg: Ship,
    icon: <Ship />,
    activeRoutes: ["/vesselInformation"],
  },
  {
    label: "All Knowledge Partners",
    url: "/admin/knowledge-partners",
    shortLabel: "AKP",
    blackImg: Users,
    whiteImg: Users,
    icon: <Users />,
    activeRoutes: ["/admin/knowledge-partners"],
  },
  {
    label: "Market Curve Analysis",
    url: "/market-curve-analysis",
    shortLabel: "Market Curve Analysis",
    blackImg: userDashboardBlack,
    whiteImg: userDashboardWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/market-curve-analysis"],
    description: "Analyze freight market trends with historical rate curves, forward projections, and comparative market intelligence.",
  },
  {
    label: "My Market Curve Analysis",
    url: "/my-market-curve-analysis",
    shortLabel: "My Market Curve Analysis",
    blackImg: userDashboardBlack,
    whiteImg: userDashboardWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/my-market-curve-analysis"],
    description: "Your personalized market curve workspace to track, annotate, and compare freight rate trends for your specific trade lanes.",
  },
  {
    label: "My Cargo Order",
    url: "/orders",
    shortLabel: "FO",
    blackImg: orderBlack,
    whiteImg: orderWhite,
    icon: <ShoppingCartIcon />,
    activeRoutes: ["/orders"],
    description:
      "Create a Cargo order of transporting goods from one location to another",
  },
  {
    label: "Cargo Analysis",
    url: "/cargo-analysis",
    shortLabel: "CA",
    blackImg: cargoAnalysisBlack,
    whiteImg: cargoAnalysisWhite,
    icon: <cargoAnalysisBlack />,
    activeRoutes: ["/cargo-analysis"],
    description: "Deep-dive analytics on cargo flows, trade lane performance, and cargo mix optimization for better chartering decisions.",
  },
  {
    label: "Estimation Analysis",
    url: "/estimation-analysis",
    shortLabel: "VA",
    blackImg: cargoAnalysisBlack,
    whiteImg: cargoAnalysisWhite,
    icon: <cargoAnalysisBlack />,
    activeRoutes: ["/estimation-analysis"],
    description: "In-depth analytical review of historical and active estimates with breakdowns on freight, fuel, port costs, and voyage performance.",
  },
  {
    label: "My Vessel",
    url: "/vesselManager",
    shortLabel: "C",
    blackImg: Ship,
    whiteImg: Ship,
    icon: <Ship />,
    activeRoutes: ["/vesselManager", "/vesselManager?tab=vesselList"],
    description:
      "Create collection of voyage used to transport goods to different locations",
  },
  {
    label: "Add Vessel",
    url: "/vesselManager?tab=addVessel&subTab=1",
    shortLabel: "AV",
    blackImg: Ship,
    whiteImg: Ship,
    icon: <Ship />,
    activeRoutes: ["/vesselManager?tab=addVessel"],
    description: "Add a new vessel manually or auto fill",
    subItems: [
      { label: "Manual", url: "/vesselManager?tab=addVessel&subTab=1" },
      { label: "Auto", url: "/vesselManager?tab=addVessel&subTab=2" },
      { label: "Users", url: "/vesselManager?tab=addVessel&subTab=3" },
      { label: "AIS", url: "/vesselManager?tab=addVessel&subTab=4" },
      { label: "Markets", url: "/vesselManager?tab=addVessel&subTab=5" },
    ],
  },
  {
    label: "Position Reader",
    url: "/positionReader",
    shortLabel: "EP",
    blackImg: emailBlack,
    whiteImg: emailWhite,
    icon: <EmailIcon />,
    activeRoutes: ["/positionReader"],
    description: "Parse and process vessel position lists from brokers and owners to quickly assess available tonnage in target areas.",
  },
  {
    label: "My Matrix",
    url: "/calculator",
    shortLabel: "C",
    blackImg: calculatorBlack,
    whiteImg: calculatorWhite,
    icon: <ListAltIcon />,
    activeRoutes: ["/calculator"],
    description:
      "Calculate the cost of transporting goods from one location to another",
  },
  {
    label: "Cargo Vessel Estimates",
    url: "/cargovessel",
    shortLabel: "MV",
    blackImg: voyagesBlack,
    whiteImg: voyagesWhite,
    icon: <ShoppingCartIcon />,
    activeRoutes: ["/cargovessel"],
    description:
      "Add Voyage details that will carry goods from one location to another",
  },
  {
    label: "Cargo Cargo Estimates",
    url: "/cargo-cargo-matrix",
    shortLabel: "CCM",
    blackImg: cargocargoBlack,
    whiteImg: cargocargoWhite,
    icon: <cargocargoBlack />,
    activeRoutes: ["/cargo-cargo-matrix"],
    description: "Run cargo-to-cargo matching estimates to evaluate the most profitable cargo combinations for a given vessel or trade lane.",
  },

  {
    label: "Vessel Vessel Estimates",
    url: "/vessel-vessel-matrix",
    shortLabel: "VVM",
    blackImg: vesselvesselBlack,
    whiteImg: vesselvesselWhite,
    icon: <vesselvesselBlack />,
    activeRoutes: ["/vessel-vessel-matrix"],
    description: "Compare multiple vessel options against the same cargo to identify the best-performing vessel for any fixture.",
  },
  {
    label: "All Estimates",
    url: "/all-estimation",
    shortLabel: "AM",
    blackImg: allEstimationBlack,
    whiteImg: allEstimationWhite,
    icon: <allEstimationWhite />,
    activeRoutes: ["/all-estimation"],
    description: "Unified dashboard to review, search, and manage all voyage estimates across cargo-vessel, cargo-cargo, and vessel-vessel combinations.",
  },
  {
    label: "Smart Laytime",
    url: "/smart-laytime",
    shortLabel: "EL",
    blackImg: laytimeBlack,
    whiteImg: laytimeWhite,
    icon: <laytimeBlack />,
    activeRoutes: ["/smart-laytime"],
    description: "Automated laytime calculations with demurrage and despatch computation, exception handling, and exportable statement generation.",
  },
  {
    label: "Smart SOF",
    url: "/smart-sof",
    shortLabel: "ES",
    blackImg: sofBlack,
    whiteImg: sofWhite,
    icon: <sofBlack />,
    activeRoutes: ["/smart-sof"],
    description: "Digital Statement of Facts management — record, verify, and share port operation timelines with all stakeholders in real time.",
  },
  {
    label: "Address Book",
    url: "/addressBook",
    shortLabel: "AB",
    blackImg: bookBlack,
    whiteImg: bookWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/addressBook"],
    description: "Centralized contact management for charterers, owners, brokers, agents, and all counterparties in your network.",
  },
  {
    label: "Distance",
    url: "/distance-matrix",
    shortLabel: "DM",
    blackImg: distanceBlack,
    whiteImg: distanceWhite,
    icon: <distanceBlack />,
    activeRoutes: ["/distance-matrix"],
    description: "Calculate sea distances between ports with zone breakdowns (Normal vs ECA) for accurate fuel cost estimation.",
  },
  {
    label: "Cargo Contract",
    url: "/contracts?tab=1",
    shortLabel: "CC",
    blackImg: contractWhite,
    whiteImg: contractBlack,
    icon: <contractBlack />,
    activeRoutes: ["/contracts?tab=1"],
    description: "Manage cargo charter party agreements and COAs with version control and compliance tracking.",
  },
  {
    label: "Vessel Contract",
    url: "/contracts?tab=2",
    shortLabel: "VC",
    blackImg: contractWhite,
    whiteImg: contractBlack,
    icon: <contractBlack />,
    activeRoutes: ["/contracts?tab=2"],
    description: "Manage time charter contracts and vessel agreements with version control and compliance tracking.",
  },
  {
    label: "Pre Fix Estimation",
    url: "/contracts?tab=3",
    shortLabel: "PE",
    blackImg: contractWhite,
    whiteImg: contractBlack,
    icon: <contractBlack />,
    activeRoutes: ["/contracts?tab=3"],
    description: "Run pre-fixture estimates linked to contracts for accurate P&L projections before committing to a fixture.",
  },
  {
    label: "Port Information",
    url: "/port-information",
    shortLabel: "PI",
    blackImg: portInfoBlack,
    whiteImg: portInfoWhite,
    icon: <portInfoBlack />,
    activeRoutes: ["/port-information"],
    description: "Comprehensive port database with berth details, draft restrictions, cargo handling capabilities, and agent contacts.",
  },
  {
    label: "Support",
    url: "/supportinformation",
    shortLabel: "support",
    blackImg: supportBlack,
    whiteImg: supportWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/supportinformation"],
    description:
      "You can manage user complaints from support page.",
  },

  {
    label: "Operations",
    url: "/operations",
    shortLabel: "operations",
    blackImg: operationBlack,
    whiteImg: operationWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/operations"],
    description: "End-to-end voyage operations management from fixture to completion, including voyage instructions and performance monitoring.",
  },
  {
    label: "Voyage List",
    url: "/voyage-list",
    shortLabel: "voyage-list",
    blackImg: voyageListBlack,
    whiteImg: voyageListWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/voyage-list"],
    description: "View all voyages across your fleet — track status, performance metrics, and key milestones from a single dashboard.",
  },
  {
    label: "Welcome",
    url: "/welcome",
    shortLabel: "HOME",
    blackImg: emailBlack,
    whiteImg: emailWhite,
    icon: <EmailIcon />,
    activeRoutes: ["/welcome"],
    description: "Home screen with platform overview, instructions, and quick access to all available modules.",
  },
  {
    label: "Support",
    url: "/support",
    shortLabel: "support",
    blackImg: supportBlack,
    whiteImg: supportWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/support"],
    description: "Integrated support system with ticket management, in-app messaging, and platform assistance.",
  },
  {
    label: "Message Box",
    url: "/messagebox",
    shortLabel: "mailbox",
    blackImg: mailboxBlack,
    whiteImg: mailboxWhite,
    icon: <ImportContactsIcon />,
    activeRoutes: ["/messagebox"],
    description: "In-platform messaging hub — communicate with counterparties, brokers, and team members with conversations tied to voyages and cargoes.",
  },
];

export const adminDrawerList = [
  {
    label: "Dashboard",
    url: "/",
    icon: <DashboardIcon />,
    activeRoutes: [
      "/",
      "/userOrganization",
      "/organization",
      "/vesselInformation",
      "/market-curve-analysis",
    ],
  },
];

export const createVesselOptions = [
  {
    label: "Built",
    name: "vesselBuilt",
    type: "number",
  },
  {
    label: "Flag",
    name: "vesselFlag",
    type: "type",
  },
  {
    label: "LOA",
    name: "vesselLOA",
    type: "number",
  },
  {
    label: "GRT",
    name: "vesselGRT",
    type: "number",
  },
  {
    label: "NGT",
    name: "vesselNRT",
    type: "number",
  },
  {
    label: "IMO",
    name: "vesselIMO",
    type: "number",
  },
  {
    label: "Class",
    name: "vesselClass",
    type: "text",
  },
  {
    label: "Bale Capacity",
    name: "vesselBaleCap",
    type: "number",
  },
  {
    label: "Gears",
    name: "vesselGears",
    type: "text",
  },
  {
    label: "Grabs",
    name: "vesselGrabs",
    type: "text",
  },
  {
    label: "Holds",
    name: "vesselHolds",
    type: "number",
  },
  {
    label: "CO2",
    name: "vesselCO2",
    type: "text",
  },
  {
    label: "AHL",
    name: "vesselAHL",
    type: "text",
  },
  {
    label: "Ice Class",
    name: "vesselIceClass",
    type: "text",
  },
  {
    label: "Shipyard",
    name: "vesselShipyard",
    type: "text",
  },
  {
    label: "Ship owner",
    name: "vesselShipowner",
    type: "text",
  },
  {
    label: "Ship country",
    name: "vesselCountry",
    type: "text",
  },
  {
    label: "Light Ship",
    name: "vesselLightShip",
    type: "number",
  },
];

export const createTableQuery = [
  {
    label: "Operation",
    name: "operation",
    type: "select",
  },
  {
    label: "Port",
    name: "port",
    type: "text",
  },
  {
    label: "Cargo Qty",
    name: "cargoQty",
    type: "number",
  },
  {
    label: "Tolerance",
    name: "tolerance",
    type: "number",
  },
  {
    label: "Rate MT/Day",
    name: "rate",
    type: "number",
  },
  {
    label: "Turn Time",
    name: "turnTime",
    type: "number",
  },
  {
    label: "PDA Remarks",
    name: "pdaRemarks",
    type: "text",
  },
  {
    label: "Grade/ Remarks",
    name: "grade",
    type: "text",
  },
  {
    label: "Freight",
    name: "freight",
    type: "number",
  },
  {
    label: "Adcom",
    name: "adcom",
    type: "number",
  },
  {
    label: "Other",
    name: "other",
    type: "number",
  },
  {
    label: "Brokerage",
    name: "brokerage",
    type: "number",
  },
  {
    label: "TTL Comm",
    name: "ttlComm",
    type: "number",
  },
  {
    label: "Net Freight",
    name: "netFrt",
    type: "number",
  },
  {
    label: "Min",
    name: "min",
    type: "number",
  },
  {
    label: "Max",
    name: "max",
    type: "number",
  },
  {
    label: "Account",
    name: "account",
    type: "text",
  },
  {
    label: "Cargo",
    name: "cargo",
    type: "text",
  },
  {
    label: "Stow Factor",
    name: "stowFactor",
    type: "number",
  },
];

export const accountCargoFields = [
  // {
  //   label: "Account",
  //   value: "account",
  // },
  {
    label: "Cargo",
    value: "name",
  },
  {
    label: "Laycan start",
    value: "laycanStartDate",
  },
  {
    label: "Laycan end",
    value: "laycanEndDate",
  },
  {
    label: "Adcom",
    value: "adcom",
  },
  {
    label: "Brokerage",
    value: "brokerage",
  },
  {
    label: "Others",
    value: "other",
  },
  {
    label: "Sf of cargo",
    value: "stowFactor",
  },
  {
    label: "Cargo Min",
    value: "min",
  },
  {
    label: "Cargo Max",
    value: "max",
  },
  {
    label: "freight Mode",
    value: "freightMode",
  },
  {
    label: "Consultant",
    value: "Tag1",
  },
  {
    label: "Consultancy",
    value: "Tag2",
  },
  {
    label: "Consultant",
    value: "Tag3",
  },
  {
    label: "Consultancy",
    value: "Tag4",
  },
];

export const portExpTariffVariables = {
  nonTechVars: [
    {
      label: "Port",
      name: "port",
      type: "text",
    },
    {
      label: "Country",
      name: "country",
      type: "text",
    },

    {
      label: "Berth",
      name: "berth",
      type: "text",
    },
    {
      label: "Cargo",
      name: "cargo",
      type: "text",
    },
    {
      label: "Local Currency",
      name: "local_currency",
      type: "text",
    },
    {
      label: "Tariff Rate Currency",
      name: "tariff_rate_currency",
      type: "text",
    },
    {
      label: "Operation",
      name: "operation",
      type: "select",
    },
  ],
  techVars: [
    {
      label: "Cargo Quantity",
      name: "cargo_quantity",
      type: "text",
    },
    {
      label: "GRT",
      name: "grt",
      type: "text",
    },
    {
      label: "NRT",
      name: "nrt",
      type: "text",
    },
    {
      label: "Duration (Days)",
      name: "duration_in_days",
      type: "text",
    },
    {
      label: "Duration (Hours)",
      name: "duration_in_hours",
      type: "text",
    },
    {
      label: "Exchange Rate",
      name: "exchange_rate",
      type: "text",
    },
    {
      label: "Add Other Multiplier",
      name: "other_multiplier",
      type: "text",
    },
  ]
};
export const vesselCalculatorMainFields = [
  {
    label: "DWT (S)",
    name: "vesselDwt",
    type: "number",
  },
  {
    label: "Draft (S)",
    name: "vesselDraftS",
    type: "number",
  },
  {
    label: "TPC",
    name: "vesselTPC",
    type: "number",
  },
  {
    label: "Grain",
    name: "vesselGrainCap",
    type: "number",
  },
  {
    label: "Built",
    name: "vesselBuilt",
    type: "number",
  },
  {
    label: "LOA",
    name: "vesselLOA",
    type: "number",
  },
  {
    label: "Beam",
    name: "vesselBeam",
    type: "number",
  },
  {
    label: "GRT",
    name: "vesselGRT",
    type: "number",
  },
  {
    label: "NRT",
    name: "vesselNRT",
    type: "number",
  },
  {
    label: "Light Ship",
    name: "vesselLightShip",
    type: "number",
  },
  {
    label: "Bale Capacity",
    name: "vesselBaleCap",
    type: "number",
  },
  {
    label: "Gears",
    name: "vesselGears",
    type: "text",
  },
  {
    label: "Grabs",
    name: "vesselGrabs",
    type: "text",
  },
  // {
  //   label: "Constants",
  //   name: "Constants",
  //   type: "text",
  // },
  {
    label: "Fuel Type",
    name: "fuelType",
    type: "text",
  },
  {
    label: "Scrubber Fitted",
    name: "vesselScrubber",
    type: "text",
  },
  {
    label: "Flag",
    name: "vesselFlag",
    type: "text",
  },
  {
    label: "Class",
    name: "vesselClass",
    type: "text",
  },
  {
    label: "MMSI",
    name: "vesselMMSI",
    type: "text",
  },

];

export const marginAndAllowancesOptions = [
  {
    label: "DWF",
    value: "dwf",
    type: "number",
    unitType: "%",
  },
  {
    label: "Speed Perf Factor",
    value: "Speed Perf Factor",
    type: "number",
    unitType: "%",
  },
  {
    label: "Speed Reduce",
    value: "Speed Reduce",
    type: "number",
    unitType: "Knots",
  },
  {
    label: "Bunker Con Allowance",
    value: "Bunker Con Allowance",
    type: "number",
    unitType: "%",
  },
];

export const expenseResultField = [
  {
    label: "Expenses Per Day",
    value: "expensesPerDay",
    type: "text",
  },
  {
    label: "On/Off Hire Survey",
    value: "hireSurvey",
    type: "text",
    itemsKey: "hireSurveyItems",
  },
  {
    label: "Canal Expenses",
    value: "canalExpenses",
    type: "text",
    itemsKey: "canalExpensesItems",
  },
  {
    label: "Additional Premium",
    value: "additionalPremium",
    type: "text",
    itemsKey: "additionalPremiumItems",
  },
  {
    label: "ILOHC",
    value: "ilohc",
    type: "text",
    itemsKey: "ilohcItems",
  },
  {
    label: "Manoevring Exp",
    value: "manoevringExp",
    type: "text",
    itemsKey: "manoevringExpItems",
  },
  {
    label: "Misc Exp",
    value: "miscExp",
    type: "text",
    itemsKey: "miscExpItems",
  },
  // {
  //     label: "Total",
  //     value: "Total",
  //     type: "text",
  //     disabled: true
  // }
];

export const resultsFields = [
  {
    label: "Frt Cost",
    value: "frtCost",
  },
  {
    label: "Profit PMT",
    value: "profitPmt",
  },
  {
    label: "Profit Net",
    value: "profitNet",
  },
  {
    label: "Net Frt Revenue",
    value: "netFrtRevenue",
  },
  {
    label: "Hire Exp",
    value: "hireExpense",
  },
  {
    label: "Fuel Expenses",
    value: "fuelExpense",
  },
  {
    label: "Others",
    value: "otherExpense",
  },
  {
    label: "Main Fuel Qty",
    value: "hsQuantity",
  },
  {
    label: "ECA Qty",
    value: "lsQuantity",
  },
  {
    label: "MGO Qty",
    value: "mgoQuantity",
  },
  {
    label: "Voy Duration",
    value: "voyageDuration",
  },
  {
    label: "Port Stay",
    value: "portStayTotal",
  },
  {
    label: "Stowage",
    value: "stowage",
  },
  {
    label: "Fuel Settle Profit",
    value: "fuelSettlementProfit",
  },
];

export const vesselVesselRevenueResultsFields = [
  {
    label: "TCO Gross Hire",
    value: "TCOGrossHire",
  },
  {
    label: "TCO Hire Commission",
    value: "TCOHireCommission",
  },
  {
    label: "Misc Revenue",
    value: "miscRevenue",
  },
  {
    label: "Fuel Settlement Profit",
    value: "FuelSettlementProfit",
  },
  {
    label: "Fuel Hand-Over Profit",
    value: "FuelHandOverProfit",
  },
  {
    label: "Total Revenue",
    value: "totalRevenue",
  },
];
export const vesselVesselExpenseResultsFields = [
  {
    label: "Fuel Expenses",
    value: "fuelExpenses",
  },
  {
    label: "Hire Expenses",
    value: "hireExpenses",
  },
  {
    label: "Port Expenses",
    value: "portExpenses",
  },
  {
    label: "Others",
    value: "others",
  },
  {
    label: "Total Expenses",
    value: "totalExpenses",
  },
];
export const vesselVesselResultsFields = [
  {
    label: "Profit",
    value: "profit",
  },
  {
    label: "Profit Per Day",
    value: "profitPerDay",
  },
  {
    label: "Voy Duration",
    value: "voyDuration",
  },
  {
    label: "Main Qty",
    value: "hsQty",
  },
  {
    label: "ECA Qty",
    value: "lsQty",
  },

  {
    label: "MGO Qty",
    value: "mgoQty",
  },
];

export const cargocargoRevenueResultsFields = [
  {
    label: "Freight",
    value: "totalGrossFreightAmountRevenue",
  },
  {
    label: "Adcom",
    value: "totalAdcomAmountRevenue",
  },
  {
    label: "Others (Tax)",
    value: "totalOthersAmountRevenue",
  },
  {
    label: "Brokerage",
    value: "totalBrokerageAmountRevenue",
  },
  {
    label: "Net Freight Revenue",
    value: "totalNetFreightRevenue",
  },
  {
    label: "Laytime Revenue",
    value: "totalLaytimeRevenueRevenue",
  },
  {
    label: "Net Revenue",
    value: "totalNetRevenue",
  },
];

export const cargocargoExpenseResultsFields = [
  {
    label: "Freight",
    value: "totalGrossFreightAmountExpense",
  },
  {
    label: "Adcom",
    value: "totalAdcomAmountExpense",
  },
  {
    label: "Others (Tax)",
    value: "totalOthersAmountExpense",
  },
  {
    label: "Brokerage",
    value: "totalBrokerageAmountExpense",
  },
  {
    label: "Net Freight Expense",
    value: "totalNetFreightExpense",
  },
  {
    label: "Laytime Expense",
    value: "totalLaytimeRevenueExpense",
  },
  {
    label: "Net Expense",
    value: "totalNetExpense",
  },
];

export const netProfitResultsFields = [
  {
    label: "Total Net Profit",
    value: "netProfit",
  },
  {
    label: "Total Freight Profit",
    value: "totalNetFreight",
  },
  {
    label: "Total Laytime Profit",
    value: "totalLaytimeProfit",
  },
];

export const portOperationHeader = [
  {
    label: "Add Opr..",
    width: 30,
    paddingLeft: "4px",
  },
  {
    label: "",
    width: 24,
  },
  {
    label: "B/L",
    width: 24,
  },
  {
    label: "Operation",
    width: 75,
  },
  {
    label: "Port",
    width: 75,
  },
  {
    label: "Dist Normal",
    width: 45,
  },
  {
    label: "Dist ECA",
    width: 35,
  },
  {
    label: "DWF",
    width: 32,
  },
  {
    label: "Speed Normal",
    width: 42,
  },
  {
    label: "Speed ECA",
    width: 42,
  },
  {
    label: "Cargo Tx",
    width: 64,
  },
  {
    label: "Rate MT/day",
    width: 45,
  },
  {
    label: "Terms",
    width: 70,
  },
  {
    label: "Factor",
    width: 35,
  },
  {
    label: "Turn time(d)",
    width: 42,
  },
  {
    label: "Extra days",
    width: 35,
  },
  {
    label: "Port Exp",
    width: 45,
  },
  {
    label: "Port stay",
    width: 45,
  },
  {
    label: "Port Emission",
    width: 55,
  },
  {
    label: "Loadline",
    width: 65,
  },
  {
    label: "Draft Res",
    width: 52,
  },
  {
    label: "Water Den",
    width: 56,
  },
  {
    label: "Supply",
    width: 48,
  },
  {
    label: "",
    width: 24,
  },
];

export const vesselVesselPortOperationHeader = [
  {
    label: "Add Opr..",
    width: 30,
    paddingLeft: "4px",
  },
  {
    label: "",
    width: 30,
  },
  // {
  //   label: "B/L",
  //   width: 30,
  // },
  {
    label: "Operation",
    width: 90,
  },
  {
    label: "Port",
    width: 80,
  },
  {
    label: "Dist Normal",
    width: 50,
    header: "Distance",
  },
  {
    label: "Dist ECA",
    width: 40,
    header: "Covered",
  },
  {
    label: "DWF",
    width: 40,
  },
  {
    label: "Arrival Time",
    width: 120,
    header: "Arrival",
  },
  {
    label: "Main",
    width: 50,
    header: "Arrival",
    justifyContent: "center",
  },
  {
    label: "ECA",
    width: 50,
    header: "Fuel",
  },
  {
    label: "MGO",
    width: 50,
  },
  {
    label: "Main",
    width: 40,
    header: "Fuel",
    justifyContent: "center",
  },
  {
    label: "ECA",
    width: 50,
    header: "Supplied",
  },
  {
    label: "MGO",
    width: 50,
    header: "at Port",
  },
  {
    label: "TripReserve",
    width: 70,
  },
  {
    label: "Paid By",
    width: 65,
  },
  {
    label: "Supply",
    width: 50,
  },
  {
    label: "Main",
    width: 40,
    header: "Fuel",
    justifyContent: "center",
  },
  {
    label: "ECA",
    width: 40,
    header: "Prices",
  },
  {
    label: "MGO",
    width: 50,
    dynamicHeader: true,
  },
  {
    label: "Extra days",
    width: 40,
  },
  {
    label: "Port Exp",
    width: 40,
  },
  {
    label: "Port Emission",
    width: 50,
  },
  {
    label: "Departure Time",
    width: 120,
    header: "Departure",
    justifyContent: "center",
  },
  {
    label: "Main",
    width: 50,
    header: "Departure",
    // justifyContent:"center"
  },
  {
    label: "ECA",
    width: 40,
    header: "Fuel",
    justifyContent: "center",
  },
  {
    label: "MGO",
    width: 40,
  },
];

export const CargoCargoOperationHeader = [
  {
    label: "Operation",
    width: 90,
    paddingLeft: "8px",
  },
  {
    label: "Port",
    width: 120,
  },
  {
    label: "Min",
    width: 80,
  },
  {
    label: "Max",
    width: 60,
  },
  {
    label: "Cargo",
    width: 60,
  },
  {
    label: "Stow Factor",
    width: 80,
  },
  {
    label: "Laycan Start",
    width: 150,
  },
  {
    label: "Laycan End",
    width: 150,
  },
  {
    label: "Actual Cargo Qty",
    width: 80,
  },
  {
    label: "Arrival Time",
    width: 150,
  },
  {
    label: "Departure Time",
    width: 140,
  },
  {
    label: "Port Stay Duration",
    width: 80,
  },
];

export const CargoCargoRevenueExpenseHeader = [
  {
    label: "Operation",
    width: 90,
    paddingLeft: "8px",
  },
  {
    label: "Port",
    width: 120,
  },
  {
    label: "Rate MT/Day",
    width: 80,
  },
  {
    label: "Terms",
    width: 80,
  },
  {
    label: "Turn Time",
    width: 80,
  },
  {
    label: "Freight Rate",
    width: 80,
  },
  {
    label: "Adcom",
    width: 60,
  },
  {
    label: "Other (Tax, etc)",
    width: 80,
  },
  {
    label: "Brokerage",
    width: 60,
  },
  {
    label: "CounterParty",
    width: 120,
  },
  {
    label: "Demurrage Rate",
    width: 80,
  },
  {
    label: "Despatch Rate",
    width: 80,
  },
  {
    label: "Additional Revenue",
    width: 80,
  },
  {
    label: "Additional Expense",
    width: 80,
  },
  {
    label: "Laytime Incurred",
    width: 80,
  },
];

export const portOperationDisabledFields2 = {
  Commence: {
    operation: true,
    cargoQuantity: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    draftRes: true,
    waterDensity: true,
    dwf: true,
    consumptionMargin: true,
    speedMargin: true,
    speedReduction: true,
    extraDays: true,
    loadline: true,
    distanceFromPreviousPort: true,
    ecaLowSulphurDistanceFromLastPort: true,
    portEmission: true,
    portExpenses: true,
    reserve: true,
    hsfo: true,
    lsfo: true,
    mgo: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
  },
  Loading: {
    operation: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
  },
  Passing: {
    cargoQuantity: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Waiting: {
    cargoQuantity: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Bunkering: {
    cargoQuantity: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Redelivery: {
    cargoQuantity: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Relay: {
    cargoQuantity: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Discharging: {
    operation: true,
    cargoQuantity: true,
    tolerance: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyAuto: true,
  },
};

export const portOperationDisabledFields = {
  Commence: {
    operation: true,
    cargoQty: true,
    tolerance: true,
    terms: true,
    other: true,
    bunkerSuppliedHSFO: true,
    bunkerSuppliedLSFO: true,
    bunkerSuppliedMGO: true,
    arrivalTime: true,
    currentHsfo: true,
    currentLsfo: true,
    currentMgo: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    draftRes: true,
    waterDensity: true,
    dwf: true,
    bnkrFactor: true,
    speedFactor: true,
    speedReduce: true,
    extraDays: true,
    loadline: true,
    distNormal: true,
    distEca: true,
    sulfur: true,
    portExp: true,
    reserve: true,
    bunkerSuppliedHSFO: true,
    bunkerSuppliedLSFO: true,
    bunkerSuppliedMGO: true,
    bunkerNonScrubberHSFO: true,
    bunkerNonScrubberLSFO: true,
    bunkerNonScrubberMGO: true,
    bunkerScrubberHSFO: true,
    bunkerScrubberLSFO: true,
    bunkerScrubberMGO: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
  },
  Loading: {
    operation: true,
    dischargeQty: true,
    cargoTxQtyAuto: true,
  },
  Passing: {
    cargoQty: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Waiting: {
    cargoQty: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Bunkering: {
    cargoQty: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Redelivery: {
    cargoQty: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Relay: {
    cargoQty: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
    canDelete: true,
  },
  Discharging: {
    operation: true,
    cargoQty: true,
    tolerance: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyAuto: true,
  },
  "Redelivery-in": {
    operation: true,
    cargoQty: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
  },
  "Delivery-out": {
    operation: true,
    cargoQty: true,
    tolerance: true,
    terms: true,
    other_tax: true,
    brokerage: true,
    account: true,
    cargo: true,
    stowFactor: true,
    freight: true,
    rate: true,
    turnTime: true,
    adcom: true,
    min: true,
    max: true,
    cargoTxQtyActual: true,
    cargoTxQtyAuto: true,
  },
};

export const termsCoEfficientTable = [
  {
    label: "SHINC",
    value: 1,
  },
  {
    label: "SHEX-12hrs",
    value: 1.0769,
  },
  {
    label: "SHEX-18hrs",
    value: 1.12,
  },
  {
    label: "SHEX-24hrs",
    value: 1.1667,
  },
  {
    label: "SHEX-30hrs",
    value: 1.2174,
  },
  {
    label: "SHEX-36hrs",
    value: 1.2727,
  },
  {
    label: "SHEX-38hrs",
    value: 1.2923,
  },
  {
    label: "SHEX-40hrs",
    value: 1.3125,
  },
  {
    label: "SHEX-42hrs",
    value: 1.3333,
  },
  {
    label: "SHEX-44hrs",
    value: 1.3548,
  },
  {
    label: "SHEX-48hrs",
    value: 1.4,
  },
  {
    label: "SHEX-55hrs",
    value: 1.4867,
  },
  {
    label: "SHEX-56hrs",
    value: 1.5,
  },
  {
    label: "SHEX-62hrs",
    value: 1.5849,
  },
  {
    label: "SHEX-63hrs",
    value: 1.6,
  },
  {
    label: "SHEX-68hrs",
    value: 1.68,
  },
  {
    label: "SHEX-72hrs",
    value: 1.75,
  },
  {
    label: "SHEX-84hrs",
    value: 2,
  },
  {
    label: "SHEX-96hrs",
    value: 2.3333,
  },
];

export const operationsOptions = [
  {
    label: "Commence",
    isDisabled: true,
  },
  {
    label: "Loading",
    isDisabled: false,
  },
  {
    label: "Passing",
    isDisabled: false,
  },
  {
    label: "Delivery-out",
    isDisabled: true,
  },
  {
    label: "Redelivery-in",
    isDisabled: true,
  },
  {
    label: "Waiting",
    isDisabled: false,
  },
  {
    label: "Bunkering",
    isDisabled: false,
  },
  {
    label: "Redelivery",
    isDisabled: false,
  },
  {
    label: "Relay",
    isDisabled: false,
  },
  {
    label: "Discharging",
    isDisabled: false,
  },
];

export const portOperationsOptions = [
  {
    label: "Commence",
    isDisabled: true,
  },
  {
    label: "Loading",
    isDisabled: true,
  },
  {
    label: "Passing",
    isDisabled: false,
  },
  {
    label: "Delivery-out",
    isDisabled: true,
  },
  {
    label: "Redelivery-in",
    isDisabled: true,
  },
  {
    label: "Waiting",
    isDisabled: false,
  },
  {
    label: "Bunkering",
    isDisabled: false,
  },
  {
    label: "Redelivery",
    isDisabled: false,
  },
  {
    label: "Relay",
    isDisabled: false,
  },
  {
    label: "Discharging",
    isDisabled: true,
  },
];

// Vessel-vessel only: a contract has at most one Delivery-out and one Redelivery-in,
// and neither can be edited once created. The option stays selectable only while none exists.
// The cargo screens keep the static lists above.
export const singleInstanceOperations = ["Delivery-out", "Redelivery-in"];
export const isSingleOperationTaken = (list, operation) =>
  singleInstanceOperations.includes(operation) &&
  Array.isArray(list) &&
  list.some((item) => item?.operation === operation);
export const getVesselVesselOperationOptions = (options, list) =>
  options.map((option) =>
    singleInstanceOperations.includes(option.label)
      ? { ...option, isDisabled: isSingleOperationTaken(list, option.label) }
      : option
  );

export const loadlineOptions = [
  { label: "S-Summer", value: "S-Summer" },
  { label: "TF-Tropical FW", value: "TF-Tropical FW" },
  { label: "F-FW", value: "F-FW" },
  { label: "T-Tropical", value: "T-Tropical" },
  { label: "W-Winter", value: "W-Winter" },
  { label: "WNA-Winter NA", value: "WNA-Winter NA" },
];

export const portEmissionOptions = [
  { label: "Normal", value: "Normal" },
  { label: "ECA", value: "ECA" },
];

export const initialCreatePortOperation = {
  no: "L",
  operation: "Bunkering",
  port: "",
  dist_Normal: 0,
  dist_eca: 0,
  dwf: 0,
  seepd_Normal: "",
  speed_eca: "",
  sea_Time: "",
  cargoQty: 0,
  rate: 0,
  terms: "SHINC",
  factor: "1.0000",
  turnTime: 0,
  extraDays: 0,
  portExp: 0,
  portStay: 0,
  sulfur: "Normal",
  loadline: "S-Summer",
  draftRes: 0,
  waterDensity: 0,
  supply: 0,
  arrival: "",
  departure: "",
  maxQty: 0,
  freight: 0,
  adCom: 0,
  brokerage: 0,
  queryId: "",
};

export const initialPortOperation = {
  account: "",
  adcom: 0,
  arrivalHsfo: "",
  arrivalLsfo: "",
  arrivalMgo: "",
  arrivalTime: "",
  broker: "",
  brokerage: 0,
  cargo: "",
  cargoDetails: {
    arrivalBunkersHSFO: 0,
    arrivalBunkersLSFO: 0,
    arrivalBunkersMGO: 0,
    bnkrFactor: 0,
    bunkerNonScrubberHSFO: 0,
    bunkerNonScrubberLSFO: 0,
    bunkerNonScrubberMGO: 0,
    bunkerScrubberHSFO: 0,
    bunkerScrubberLSFO: 0,
    bunkerScrubberMGO: 0,
    bunkerSuppliedHSFO: 0,
    bunkerSuppliedLSFO: 0,
    bunkerSuppliedMGO: 0,
    cargoId: "",
    distEca: 0,
    distNormal: 0,
    id: "",
    organizationId: "",
    paidBy: "Operator",
    reserve: "User",
    speedFactor: 0,
    speedReduce: 0,
  },
  cargoId: "",
  cargoQty: 0,
  cargoTx: "",
  country: "",
  createdDate: "",
  createdUser: "",
  departureHsfo: "",
  departureLsfo: "",
  departureMgo: "",
  departureTime: "",
  dischargeQty: 0,
  draftRes: 0,
  duration: "",
  dwf: 0,
  extraDays: 0,
  factor: 0,
  firstLoadPort: "",
  freight: "",
  freightMode: "",
  grade: "",
  hire: "",
  hireGbb: "",
  id: "",
  index: 0,
  label: "",
  lastDischargePort: "",
  lastModifiedDate: "",
  lastModifiedUser: "",
  lat: "",
  laycanBegin: "",
  laycanEnd: "",
  lbmarker: "",
  lng: "",
  loadline: "",
  lumpsumFreight: 0,
  max: 0,
  min: 0,
  multiParcelMode: "",
  netFrt: 0,
  notes: "",
  operation: "",
  organizationId: "",
  other: 0,
  pdaRemarks: "",
  port: "",
  portExp: 0,
  portId: "",
  portStay: 0,
  profit: "",
  queryId: "",
  rate: 0,
  seaTime: 0,
  speedECA: "",
  speedNormal: "",
  stowFactor: 0,
  sulfur: "",
  supply: 0,
  system: false,
  tcEq: "",
  tcGbb: "",
  terms: "",
  tolerance: 0,
  ttlComm: 0,
  turnTime: 0,
  version: 0,
  voyType: "",
  waterDensity: 0,
};

export const fuelPriceOptions = [
  {
    label: "Type-1",
    value: "TYPE0",
    newLabel: "Non-Scrubber",
  },
  {
    label: "Type-2",
    value: "TYPE1",
    newLabel: "Scrubber",
  },
  {
    label: "Type-3",
    value: "TYPE2",
    newLabel: "LNG",
  },
  {
    label: "Type-4",
    value: "TYPE3",
    newLabel: "Hydrogen",
  },
  {
    label: "Type-5",
    value: "TYPE4",
    newLabel: "Bio-Fuel",
  },
];

export const scrubberOptions = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];


export const initialAddFleet = {
  checked: false,
  vesselName: '',
  vesselLabel: '',
  dwt: 0,
  port: "",
  dateOpen: Date.now(),
  tcEq: 0,
  gbb: 0,
  hirePerDay: 0,
  hireGbb: 0,
  frtCost: 0,
  profit: 0,
  loadability: 0,
  arrivalLoadPort: "",
  extra_Exp: "",
  bod: 0,
  constan: 0,
  lat: 0,
  lng: 0,
  remark: "",
  vesselId: "",
  vessel: "",
  selectedVessel: {
    ...initialRowData
  },
  selectedPort: {},
};

export const addFleetRegionOptions = [
  {
    label: "Unknown",
    value: "Unknown",
  },
  {
    label: "OTHERS",
    value: "OTHERS",
  },
  {
    label: "BALTIC",
    value: "BALTIC",
  },
  {
    label: "INDIA SUBCOUNT",
    value: "INDIA SUBCOUNT",
  },
  {
    label: "AUSTRALIA/NZ",
    value: "AUSTRALIA/NZ",
  },
  {
    label: "UKC",
    value: "UKC",
  },
  {
    label: "BLACK SEA",
    value: "BLACK SEA",
  },
  {
    label: "FAR EAST",
    value: "FAR EAST",
  },
  {
    label: "WC LATIN AMERICA",
    value: "WC LATIN AMERICA",
  },
  {
    label: "EAST/SOUTH AFRICA",
    value: "EAST/SOUTH AFRICA",
  },
  {
    label: "EC LATIN AMERICA",
    value: "EC LATIN AMERICA",
  },
  {
    label: "CARIBS/ECMEX",
    value: "CARIBS/ECMEX",
  },
  {
    label: "USAC/ECC",
    value: "USAC/ECC",
  },
  {
    label: "MED",
    value: "MED",
  },
  {
    label: "USWC/WCM",
    value: "USWC/WCM",
  },
  {
    label: "USG",
    value: "USG",
  },
  {
    label: "MIDDLE EAST",
    value: "MIDDLE EAST",
  },
  {
    label: "SOUTH EAST ASIA",
    value: "SOUTH EAST ASIA",
  },
  {
    label: "WAF",
    value: "WAF",
  },
];

export const addFleetVesselTypeOptions = [
  {
    label: "All",
    value: "0_99999999",
  },
  {
    label: "Mini Bulk 0-20000",
    value: "0_20000",
  },
  {
    label: "HandyBulk 20,000-40,000",
    value: "20001_40000",
  },
  {
    label: "Supra/Ultra 40,000-68,000",
    value: "40001_68000",
  },
  {
    label: "P/Pmx 68,000-100,000",
    value: "68001_100000",
  },
  {
    label: "Cape 100,000 & above",
    value: "100001_99999999",
  },
];

export const addFleetGearsOptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Geared",
    value: "Geared",
  },
  {
    label: "Gearless",
    value: "Gearless",
  },
];

export const refreshCanalOptions = [
  {
    label: "Avoid Suez Canal",
    value: "suez",
  },
  {
    label: "Avoid Panama Canal",
    value: "panama",
  }
];

export const addQueryInitialData = {
  name: "",
  cve: 0,
  insurance: 0,
  hireSurvey: 0,
  canalExpenses: 0,
  additionalPremium: 0,
  ilohc: 0,
  manoevringExp: 0,
  miscExp: 0,
  miscRevenue: 0,
  message: "",
  qtyMode: "MOLOO",
  freightMode: "Single Freight",
  access: "private",
  scrubberType: false,
  laycanStartDate: null,
  laycanEndDate: null,
  bnkDelhs: 0,
  bnkDells: 0,
  bnkDelmgo: 0,
};

export const queryPortDisabledFields = {
  Loading: {},
  Discharging: {
    min: true,
    max: true,
    cargoQty: true,
    tolerance: true,
    stowFactor: true,
    freight: true,
    adcom: true,
    other: true,
    brokerage: true,
    account: true,
    cargo: true,
  },
};

export const initialVesselState = {
  vesselAHL: "",
  vesselBalConsmHS1: 0,
  vesselBalConsmHS2: 0,
  vesselBalConsmHS3: 0,
  vesselBalConsmHS4: 0,
  vesselBalConsmLS1: 0,
  vesselBalConsmLS2: 0,
  vesselBalConsmLS3: 0,
  vesselBalConsmLS4: 0,
  vesselBalConsmMGO1: 0,
  vesselBalConsmMGO2: 0,
  vesselBalConsmMGO3: 0,
  vesselBalConsmMGO4: 0,
  vesselBalSpd1: 0,
  vesselBalSpd2: 0,
  vesselBalSpd3: 0,
  vesselBalSpd4: 0,
  vesselBaleCap: 0,
  vesselBeam: 0,
  vesselBuilt: 0,
  vesselCO2: "",
  vesselClass: "",
  vesselCountry: "",
  vesselDraftS: 0,
  vesselDwt: 0,
  vesselFlag: "",
  vesselGRT: 0,
  vesselGears: "",
  vesselGrabs: "",
  vesselGrainCap: 0,
  vesselHatches: 0,
  vesselHolds: 0,
  vesselIMO: 0,
  vesselIceClass: "",
  vesselLOA: 0,
  vesselLdnConsmHS1: 0,
  vesselLdnConsmHS2: 0,
  vesselLdnConsmHS3: 0,
  vesselLdnConsmHS4: 0,
  vesselLdnConsmLS1: 0,
  vesselLdnConsmLS2: 0,
  vesselLdnConsmLS3: 0,
  vesselLdnConsmLS4: 0,
  vesselLdnConsmMGO1: 0,
  vesselLdnConsmMGO2: 0,
  vesselLdnConsmMGO3: 0,
  vesselLdnConsmMGO4: 0,
  vesselLdnSpd1: 0,
  vesselLdnSpd2: 0,
  vesselLdnSpd3: 0,
  vesselLdnSpd4: 0,
  vesselLightShip: 0,
  vesselMMSI: 0,
  vesselNRT: 0,
  vesselName: "",
  vesselPDischConsmHS: 0,
  vesselPDischConsmLS: 0,
  vesselPDischConsmMGO: 0,
  vesselPIdleConsmHS: 0,
  vesselPIdleConsmLS: 0,
  vesselPIdleConsmMGO: 0,
  vesselPLdgConsmHS: 0,
  vesselPLdgConsmLS: 0,
  vesselPLdgConsmMGO: 0,
  fuelType: "TYPE0",
  vesselShipowner: "",
  vesselShipyard: "",
  vesselSource: "",
  vesselTPC: 0,
  vesselType: "",
  vesselVExtraConsmHS: 0,
  vesselVExtraConsmLS: 0,
  vesselVExtraConsmMGO: 0,
  vesselBalComb1Selected: false,
  vesselBalComb2Selected: false,
  vesselBalComb3Selected: false,
  vesselBalComb4Selected: false,
  vesselLadComb1Selected: false,
  vesselLadComb2Selected: false,
  vesselLadComb3Selected: false,
  vesselLadComb4Selected: false,
};

export const vesselTableHeading = [
  { id: "accordian", title: "", showOrder: false, align: "center", width: 26 },
  { id: "vesselName", title: "Vessel Name", showOrder: false, align: "left" },
  { id: "dwt", title: "DWT", showOrder: false, align: "right", width: 55 },
  { id: "port", title: "Port", showOrder: false, align: "left" },
  { id: "dateOpening", title: "Date Opening", showOrder: false, align: "left", width: 110 },
  { id: "tcEq", title: "TC Eq", showOrder: true, align: "right", width: 55 },
  { id: "gbb", title: "GBB", showOrder: false, align: "right", width: 45 },
  { id: "hirePerDay", title: "Hire Per Day", showOrder: false, align: "right", width: 75 },
  { id: "hireGbb", title: "Hire GBB", showOrder: false, align: "right", width: 45 },
  { id: "frtCost", title: "Frt Cost", showOrder: true, align: "right", width: 75 },
  { id: "profitNet", title: "Profit", showOrder: true, align: "right", width: 65 },
  { id: "loadability", title: "Loadability", showOrder: true, align: "right", width: 55 },
  { id: "eta", title: "ETA", showOrder: false, align: "left", width: 105 },
  { id: "vesselPremium", title: "Vessel Premium", showOrder: true, align: "right", width: 58 },
  { id: "positionPremium", title: "Position Premium", showOrder: true, align: "right", width: 62 },
  { id: "remarks", title: "Remarks/Broker/etc", showOrder: false, align: "left", width: 90 },
  { id: "actions", title: "Actions", showOrder: false, align: "center", width: 58 },
];

export const vesselTableHeadingViewOnly = [
  { id: "checkbox", title: "checkbox", showOrder: true },
  { id: "vesselName", title: "Vessel Name", showOrder: true },
  { id: "dwt", title: "DWT", showOrder: true },
  { id: "port", title: "Port", showOrder: true },
  { id: "dateOpening", title: "Date Opening", showOrder: false },
  { id: "gbb", title: "GBB", showOrder: true },
  { id: "hirePerDay", title: "Hire Per Day", showOrder: true },
  { id: "hireGbb", title: "Hire GBB", showOrder: true },
  // { id: "eta", title: "ETA", showOrder: true },
  // { id: "rank", title: "Rank", showOrder: false },
  { id: "remarks", title: "Remarks/Broker/etc", showOrder: false },
  // { id: "actions", title: "Actions", showOrder: false },
];

export const vesselDetailsOption1 = [
  {
    label: "Flag",
    name: "vesselFlag",
    isExtra: false,
  },
  {
    label: "Class",
    name: "vesselClass",
    isExtra: false,
  },
  {
    label: "IMO Number",
    name: "vesselIMO",
    isExtra: false,
  },
  {
    label: "Holds",
    name: "vesselHolds",
    isExtra: false,
  },
  {
    label: "Hatches",
    name: "vesselHatches",
    isExtra: false,
  },
  {
    label: "CO2",
    name: "vesselCO2",
    isExtra: false,
  },
  {
    label: "AHL",
    name: "vesselAHL",
    isExtra: false,
  },
  {
    label: "Ice Class",
    name: "vesselIceClass",
    isExtra: false,
  },
  {
    label: "Suez GRT",
    name: "suezGRT",
    isExtra: true,
  },
  {
    label: "Suez NRT",
    name: "suezNRT",
    isExtra: true,
  },
  {
    label: "Panama NT",
    name: "panamaNT",
    isExtra: true,
  },
  {
    label: "IFO Capacity",
    name: "ifoCapacity",
    isExtra: true,
  },
  {
    label: "MGO Capacity",
    name: "mgoCapacity",
    isExtra: true,
  },
  {
    label: "FW Capacity",
    name: "fwCapacity",
    isExtra: true,
  },
];

export const vesselDetailsOption2 = [
  {
    label: "Type",
    name: "vesselType",
    isExtra: false,
  },
  {
    label: "Sub Type",
    name: "subType",
    isExtra: true,
  },
  {
    label: "Call Sign",
    name: "callSign",
    isExtra: true,
  },
  {
    label: "MMSI Number",
    name: "vesselMMSI",
    isExtra: false,
  },
  {
    label: "Ship Yard Built",
    name: "vesselShipyard",
    isExtra: false,
  },
  {
    label: "Ship Owner",
    name: "vesselShipowner",
    isExtra: false,
  },
  {
    label: "Ship Country",
    name: "vesselCountry",
    isExtra: false,
  },
  {
    label: "E-mail",
    name: "email",
    isExtra: true,
  },
  {
    label: "Phone 1",
    name: "phone1",
    isExtra: true,
  },
  {
    label: "Phone 2",
    name: "phone2",
    isExtra: true,
  },
  {
    label: "P & I Club",
    name: "pandIClub",
    isExtra: true,
  },
  {
    label: "Created Timestamp",
    name: "null",
    isExtra: true,
    isDisabled: true,
  },
  {
    label: "Last Updated Time",
    name: "lastModifiedDate",
    isExtra: false,
    isDisabled: true,
  },
  {
    label: "Last Updated By",
    name: "savedBy",
    isExtra: false,
    isDisabled: true,
  },
];

export const cargoFuelPriceStep = {
  notes: [
    "* 5 set of fuel prices can be used to calculate voyages, However you can enter only those prices which you intend to use for your vessels",
    "Type-1: Non-scrubber vessels (most prevalent)",
    "Type-2: Scrubber fitted (O)",
    "Type-3: Scrubber fitted (C)",
    "Type-4: LNG (or custom combination)",
    "Type-5: Ammonia (or custom combination)",
    "When you choose Fuel type in your vessel detail, the corresponding fuel price set from here will be used to calculate that vessel. Multiple vessels will be calculated simultaneously with these prices."
  ],
  comments: [
    "Main fuel is consumed in normal (0.5%) area, ECA fuel in ECA areas (0.1%). At any time, only one of them will be consumed.",
    "For our voyage calculations, we are concerned with only prices of the fuel to be used. (No worries about fuel grades and specs at this stage)",
    "As our system calculates and compares all vessels simultaneously, it is smart to enter all combination of fuel prices now.",
    "These fuel prices will be considered only in default mode of fuel calculation method. For all other methods, respective prices from vessel details shall be used.",
  ],
};

export const shortNameForAddressBook = [
  {
    label: "Shipping Agents",
    value: "shippingAgents",
  },
  {
    label: "Own Entities",
    value: "ownEntities",
  },
  {
    label: "Brokers",
    value: "brokers",
  },
  {
    label: "Charterers",
    value: "charterers",
  },
  {
    label: "Ship Owners",
    value: "shipOwners",
  },
  {
    label: "Fuel Suppliers",
    value: "fuelSuppliers",
  },
  {
    label: "Others",
    value: "others",
  },
  {
    label: "Port Service Supplier",
    value: "portServiceSupplier",
  },
  {
    label: "Port/Terminal",
    value: "portTerminal",
  },
  {
    label: "Receiver",
    value: "receiver",
  },
  {
    label: "Shipper",
    value: "shipper",
  },
];

export const individualDummyData = [
  {
    individual_title: "Mr.",
    individual_firstName: "John",
    individual_middleName: "Doe",
    individual_lastName: "Smith",
    individual_webPage: "https://johnsmith.com",
    individual_gender: "male",
    individual_birthdate: "1990-01-01",
    individual_anniversary: "2015-06-15",
    individual_location: "New York, USA",
    individual_language: "English",
    individual_emailPersonal: "john.smith@email.com",
    individual_emailPersonal2: "johndoe123@email.com",
    individual_mobilePersonal: "+1234567890",
    individual_mobilePersonal2: "+0987654321",
    individual_homeAddress: "123 Main St, Apt 4B",
    individual_personal_city: "New York",
    individual_personal_state: "NY",
    individual_personal_postalCode: "10001",
    individual_personal_country: "USA",
    individual_message: "Loream ipnus liomns",
    individual_company: "Tech Corp",
    individual_jobTitle: "Software Engineer",
    individual_department: "Engineering",
    individual_officeLocation: "Tech Corp Headquarters",
    individual_mobileNoOfficial: "+1122334455",
    individual_mobileNoOfficial2: "+2233445566",
    individual_emailOfficial: "john.smith@techcorp.com",
    individual_emailOfficial2: "john.doe@techcorp.com",
    individual_emailOfficial3: "j.smith@techcorp.com",
    individual_officeAddress: "456 Tech Blvd, Suite 200",
    individual_professional_city: "San Francisco",
    individual_professional_state: "CA",
    individual_professional_postalCode: "94105",
    individual_professional_country: "USA",
  },
];

export const organisationDummyData = [
  {
    organisation_fullName: "Tech Corp Inc.",
    organisation_fullStyle: "Corporation",
    organisation_typeTags: "Tech, Software, Engineering",
    organisation_officeLocation: "Tech Corp HQ, San Francisco",
    organisation_contactPerson: "Alice Johnson",
    organisation_contactPerson2: "Bob Williams",
    organisation_mobileOfficial: "+15551234567",
    organisation_mobileOfficial2: "+15559876543",
    organisation_officeAddress: "123 Tech Park, Suite 500",
    organisation_emailOfficial: "contact@techcorp.com",
    organisation_emailOfficial2: "support@techcorp.com",
    organisation_emailOfficial3: "info@techcorp.com",
    organisation_city: "San Francisco",
    organisation_state: "CA",
    organisation_postalCode: "94107",
    organisation_country: "USA",
    organisation_shortName: "TCI",
    organisation_notes:
      "Leading tech company specializing in software development.",
  },
];


export const initialAddtariff = {
  tariff_name: '',
  tariff_description: '',
  country: '',
  berth: '',
  cargo: '',
  local_currency: '',
  tariff_rate_currency: '',
  operation: '',
  cargo_quantity: 0,
  grt: 0,
  nrt: 0,
  duration_in_days: 0,
  duration_in_hours: 0,
  exchange_rate: 0,
  tariff_structure_details: '',
  parforma_port_tariff: [{
    label: "Port Dues",
    unitRate: 0,
    factors: [
      "GRT",
      "Hours"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Pilotage",
    unitRate: 0,
    factors: [
      "GRT"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Berth Hire",
    unitRate: 0,
    factors: [
      "Hours",
      "NRT",
      "GRT"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Priority Berth Hire",
    unitRate: 0,
    factors: [
      "Hours"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Stream Dues",
    unitRate: 0,
    factors: [
      "fixed"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Shore Gangway Charges",
    unitRate: 0,
    factors: [
      "GRT"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Tug charges",
    unitRate: 0,
    factors: [
      "NRT"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "VTS Fee",
    unitRate: 0,
    factors: [
      "fixed"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Draft Survey",
    unitRate: 0,
    factors: [
      "fixed"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Lumpsum Agency Fee",
    unitRate: 0,
    factors: [
      "fixed"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Port Seafarers Association Charges",
    unitRate: 0,
    factors: [
      "Cargo Quantity"
    ],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Light dues",
    unitRate: 0,
    factors: ["GRT"],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  {
    label: "Customs overtime Approx",
    unitRate: 0,
    factors: [],
    netAmount: 0,
    tax: 0,
    gross_local: 0,
    gross_tariff: 0
  },
  ],
  other_multiplier: 0,
  port_description: '',
  net_amount: 0,
  total_gross: 0,
  total_exchange_rate: 0,
}

export const dummyVesselIndexData = [
  {
    "indexValue": 1282,
    "Date": "01-Feb-2025"
  },
  {
    "indexValue": 1290,
    "Date": "03-Feb-2025"
  },
  {
    "indexValue": 1287,
    "Date": "05-Feb-2025"
  },
  {
    "indexValue": 1295,
    "Date": "07-Feb-2025"
  },
  {
    "indexValue": 1301,
    "Date": "09-Feb-2025"
  },
  {
    "indexValue": 1298,
    "Date": "11-Feb-2025"
  },
  {
    "indexValue": 1305,
    "Date": "13-Feb-2025"
  },
  {
    "indexValue": 1312,
    "Date": "15-Feb-2025"
  },
  {
    "indexValue": 1306,
    "Date": "17-Feb-2025"
  },
  {
    "indexValue": 1320,
    "Date": "19-Feb-2025"
  },
  {
    "indexValue": 1325,
    "Date": "21-Feb-2025"
  },
  {
    "indexValue": 1318,
    "Date": "23-Feb-2025"
  },
  {
    "indexValue": 1330,
    "Date": "25-Feb-2025"
  },
  {
    "indexValue": 1338,
    "Date": "27-Feb-2025"
  },
  {
    "indexValue": 1345,
    "Date": "01-Mar-2025"
  },
  {
    "indexValue": 1352,
    "Date": "03-Mar-2025"
  },
  {
    "indexValue": 1347,
    "Date": "05-Mar-2025"
  },
  {
    "indexValue": 1360,
    "Date": "07-Mar-2025"
  },
  {
    "indexValue": 1368,
    "Date": "09-Mar-2025"
  },
  {
    "indexValue": 1375,
    "Date": "11-Mar-2025"
  },
  {
    "indexValue": 1382,
    "Date": "13-Mar-2025"
  },
  {
    "indexValue": 1390,
    "Date": "15-Mar-2025"
  }
];

export const mapDivisions = [
  {
    "type": "Feature",
    "properties": {
      "info": "Pacific Ocean - Far East"
    },
    "geometry": {
      "coordinates": [
        [
          [99, 66], [99, 26], [180, 26], [180, 66]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Pacific Ocean - South East Asia"
    },
    "geometry": {
      "coordinates": [
        [
          [99, 26], [99, -12], [126, -12], [126, -10.5], [155, -10.5], [155, -33], [180, -33], [180, 26]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Australia-NZ & Islands"
    },
    "geometry": {
      "coordinates": [
        [
          [99, -12], [99, -60], [126, -60], [155, -60], [180, -60], [180, -33], [155, -33], [155, -10.5], [126, -10.5], [126, -12]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Indian Ocean - East"
    },
    "geometry": {
      "coordinates": [
        [
          [77.5, 26], [77.5, -60], [99, -60], [99, 26]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Indian Ocean West"
    },
    "geometry": {
      "coordinates": [
        [
          [56, 10], [56, -60], [60, -60], [77.5, -60], [77.5, 26], [60, 26], [60, 10]
        ]
      ],
      "type": "Polygon"
    }
  }, {
    "type": "Feature",
    "properties": {
      "info": "Middle East : PG & Red Sea"
    },
    "geometry": {
      "coordinates": [
        [
          [32, 31], [32, 10], [60, 10], [60, 31]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "East & South Africa"
    },
    "geometry": {
      "coordinates": [
        [
          [20, 10], [20, -60], [56, -60], [56, 10]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Black Sea"
    },
    "geometry": {
      "coordinates": [
        [
          [27, 48], [27, 40], [56, 40], [56, 48]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Mediterranean Region"
    },
    "geometry": {
      "coordinates": [
        [
          [-5.5, 42], [-5.5, 30], [2, 30], [27, 30], [37, 30], [37, 40], [27, 40], [27, 46], [2, 46], [2, 42]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Baltic"
    },
    "geometry": {
      "coordinates": [
        [
          [9, 66], [9, 53], [31, 53], [31, 66]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "UK and Continents"
    },
    "geometry": {
      "coordinates": [
        [
          [-44, 66], [-44, 36], [-5.5, 36], [-5.5, 42], [2, 42], [2, 46], [9, 46], [9, 66], [2, 66], [-5.5, 66]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "West Africa"
    },
    "geometry": {
      "coordinates": [
        [
          [-44, 36], [-44, 8], [-26, 8], [-26, -60], [-5.5, -60], [20, -60], [20, 30], [-5.5, 30], [-5.5, 36], [-26, 36]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "East Coast South America"
    },
    "geometry": {
      "coordinates": [
        [
          [-70, 8], [-70, -60], [-26, -60], [-26, 8], [-44, 8], [-44, 27], [-59.5, 27], [-59.5, 8]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "East Coast North America"
    },
    "geometry": {
      "coordinates": [
        [
          [-100, 66], [-100, 32], [-82, 32], [-82, 27], [-44, 27], [-44, 66], [-82, 66]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "US-Mexico Gulf & Carribean"
    },
    "geometry": {
      "coordinates": [
        [
          [-100, 32], [-100, 18], [-90, 18], [-90, 14], [-84, 14], [-84, 9], [-83, 9], [-83, 8.5], [-82, 8.5], [-80, 8.5], [-80, 9.1], [-78, 9.1], [-78, 8], [-59.5, 8], [-59.5, 27], [-78, 27], [-80, 27], [-82, 27], [-82, 32], [-83, 32], [-84, 32], [-90, 32]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "West Coast South America"
    },
    "geometry": {
      "coordinates": [
        [
          [-180, 8], [-180, -60], [-70, -60], [-70, 8]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "West Coast North America"
    },
    "geometry": {
      "coordinates": [
        [
          [-180, 66], [-180, 8], [-78, 8], [-78, 9.1], [-80, 9.1], [-80, 8.5], [-83, 8.5], [-83, 9], [-84, 9], [-84, 14], [-90, 14], [-90, 18], [-100, 18], [-100, 66]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "Northern Russia"
    },
    "geometry": {
      "coordinates": [
        [
          [173, 68], [173, 60], [44, 60], [44, 68], [100, 80]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "North Polar Region"
    },
    "geometry": {
      "coordinates": [
        [
          [-180, 90], [-180, 66], [180, 66], [180, 90]
        ]
      ],
      "type": "Polygon"
    }
  },
  {
    "type": "Feature",
    "properties": {
      "info": "South Polar Region"
    },
    "geometry": {
      "coordinates": [
        [
          [-180, -60], [-180, -90], [180, -90], [180, -60]
        ]
      ],
      "type": "Polygon"
    }
  }
]